import forge from "node-forge";
import {isEmptyOrNullOrUndefined} from "../Datautil.ts";

export interface CallJSBridgeInfoType {
    token?: string,
    nickName?: string,
    uid?: string
}

// CGTN原生提供的JS桥接，整理到这个类中，用于对接app本身的登录
export class NativeBridge {
    // IOS端的CGTN提供的判断app是否已经登录的方法，回调回来相应的用户数据，除了没有头像其它的都有
    public static callJSBridgeLoginInfoForIos(callBack: (data: CallJSBridgeInfoType) => void): void {
        let appkey: string;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.webkit.messageHandlers.initJSBridge.postMessage(null);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.initJSBridgeCallBack = function (data) {
            appkey = data?.data?.appKey;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            window.isInWebView = true;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            window.webkit.messageHandlers.isAppLogin.postMessage(null);
        }

        // ios的是否登录回调
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.isAppLoginCallBack = function (data) {
            if (data?.data?.isAppLogin) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                window.webkit.messageHandlers.getUserInfo.postMessage(null)
                // 已经登录
                return
            }
        }

        // ios的获取用户信息回调
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.getUserInfoCallBack = function (data) {
             
            const token = NativeBridge.decrypt(data?.data.token, appkey);

            const nickName = NativeBridge.decrypt(data?.data.nickName, appkey);

            const uid = NativeBridge.decrypt(data?.data.uid, appkey);

            const userInfo: CallJSBridgeInfoType = {
                token,
                nickName,
                uid
            }
            callBack(userInfo)
        }
    }

    // android - 在一开始需要初始化，然后才能获得key
    public static callJSBridgeLoginInfoForAndroid(callBack: (data: CallJSBridgeInfoType) => void): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const str = YSPAndroid.initJSBridge();
        // 解析 JSON 字符串为 JavaScript 对象
        const obj = JSON.parse(str);

        // 访问解析后的对象属性
        const data = JSON.parse(obj.data);

        const appkey = data.appKey;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const loginJson = YSPAndroid.isAppLogin();

        // 解析 JSON 字符串为 JavaScript 对象
        const objLogin = JSON.parse(loginJson);

        // 访问解析后的对象属性
        const isLogin = JSON.parse(objLogin.data);

        if (isLogin.isAppLogin) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            const userInfoJson = YSPAndroid.getUserInfo();
            const objInfoJson = JSON.parse(userInfoJson);
            const objInfoJsonData = JSON.parse(objInfoJson.data);

            const token = NativeBridge.decrypt(objInfoJsonData.token, appkey);

            const nickName = NativeBridge.decrypt(objInfoJsonData.nickName, appkey);

            const uid = NativeBridge.decrypt(objInfoJsonData.uid, appkey);

            const userInfo: CallJSBridgeInfoType = {
                token,
                nickName,
                uid
            }
            callBack(userInfo)
        }
    }

    // CGTN的APP还没登录时，点击登录的方法：android
    public static loginInAndroid(callBack: (data: CallJSBridgeInfoType) => void): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        YSPAndroid.showLoginPage();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.showLoginPageCallBack = function (data) {
            let result = data?.data || {}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            if (getPlatform === 'android') {
                result = JSON.parse(data?.data || "{}")
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                const token = NativeBridge.decrypt(result.token, appkey);
                if (token) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-expect-error
                    const token = NativeBridge.decrypt(result.token, appkey);
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-expect-error
                    const nickName = NativeBridge.decrypt(result.nickName, appkey);
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-expect-error
                    const uid = NativeBridge.decrypt(result.uid, appkey);
                    const userInfo: CallJSBridgeInfoType = {
                        token,
                        nickName,
                        uid
                    }
                    callBack(userInfo)
                }
            }
        }
    }

    // CGTN的APP还没登录时，点击登录的方法：IOS
    public static loginInIos(callBack: (data: CallJSBridgeInfoType) => void): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.webkit.messageHandlers.showLoginPage.postMessage(null);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.showLoginPageCallBack = function (data) {

            const result = data?.data || {}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            const token = NativeBridge.decrypt(result.token, appkey);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            const nickName = NativeBridge.decrypt(result.nickName, appkey);

            // const phone = NativeBridge.decrypt(result.phone, appkey);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            const uid = NativeBridge.decrypt(result.uid, appkey);

            // const guid = NativeBridge.decrypt(result.guid, appkey);

            // const openId = NativeBridge.decrypt(result.opendId, appkey);
            const userInfo: CallJSBridgeInfoType = {
                token,
                nickName,
                uid
            }
            callBack(userInfo)
        }
    }


    // 数据解密，所有cgtn返回的数据，只要不是bool值，都需要解密
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    static decrypt(datamsg, keyStr) {
        if(isEmptyOrNullOrUndefined(datamsg)){
            return "";
        }
        datamsg = window.atob(datamsg)
        const iv = datamsg.slice(0, 12)
        const tag = datamsg.slice(-16)
        const data = datamsg.slice(12, datamsg.length - 16)

        const decipher = forge.cipher.createDecipher("AES-GCM", keyStr)
        decipher.start({
            iv: iv,
            tag: tag,
        })
        decipher.update(forge.util.createBuffer(data))
        const pass = decipher.finish()
        if (pass) {
            return decipher.output.toString()
        }
    }
}